module.exports = __webpack_public_path__ + "static/media/mcActive.b726c000.svg";